var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/internals/engine-is-node.js
// module id = nlhF
// module chunks = 04af